<template lang="pug">
div.root
  .disabledOverflow(v-if="disabled", @click="$emit('click')")
  select.form-control(
    type="text", 
    v-model='localSelectedGroup', 
    :disabled="disabled", 
    v-if='groopsAreLoaded')
    option(:value='null') {{$t('selectAGroup.placeholder')}}
    template(v-for='(groups, type) in groupsPerTypeAndUnused', v-if="type != 'UNUSED'")
      option(disabled='disabled', v-if="type != 'undefined'") {{$t('groups.types.' + type)}}
      option(v-for='(group, key) in groups', :value='group')
        template(v-if="group.type") &nbsp;&nbsp;&nbsp;
        | {{group.name}}
    template(v-for='(groups, type) in groupsPerTypeAndUnused', v-if="type == 'UNUSED'")
      option(disabled='disabled', v-if="type != 'undefined'") {{$t('groups.types.' + type)}}
      option(v-for='(group, key) in groups', :value='group')
        template(v-if="group.type") &nbsp;&nbsp;&nbsp;
        | {{group.name}}
  template(v-else)
    .form-control {{$t("globals.loading")}}
</template>
<script>

import {mapGetters} from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedGroup: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      localSelectedGroup: this.selectedGroup
    }
  },
  mounted () {
    this.localSelectedGroup = this.selectedGroup
  },
  computed: {
    ...mapGetters('groops', [
      'groopsAreLoaded',
      'groupsPerTypeAndUnused'
    ])
  },
  watch: {
    localSelectedGroup () {
      this.$emit('update:selectedGroup', this.localSelectedGroup)
    },
    selectedGroup () {
      this.localSelectedGroup = this.selectedGroup
    }
  }
}
</script>
<style scoped>
.root{
  position: relative;
}
.disabledOverflow{
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// SelectAGroup.vue?8469739e